import { PUBLICATION_SHOW_MAP_KEY } from "@/config/query-parameter-consts";
import { useRanaSearchState } from "@/hooks/router/rana-search-state";

export function usePublicationShowMap() {
  return useRanaSearchState(PUBLICATION_SHOW_MAP_KEY, false);
}
